import LinkedAccount from './LinkedAccount';

export const models = {
  LinkedAccount,
};
